const hook = {
    missing_events: 'Necesita proporcionar al menos un evento.',
    send_test_payload_failed: 'Error al enviar carga útil de prueba: {{message}}',
    endpoint_responded_with_error: 'El punto de enlace respondió con un error.',
};
export default Object.freeze(hook);
